import _ from '@lodash';
import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';
import ListView from './listView';
import useRouter from '@fuse/hooks/useRouter';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';


function EndUsersAccountsTable(props) {
	const router = useRouter();

	let serviceRequests;
	
	if(router.query.report_name){
		serviceRequests = props.serviceRequests.slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage);
	}else{
		serviceRequests = props.serviceRequests;
	}




	if(props.loading){
		return (<FuseLoading/>)
	}

	if (!props.viewServiceRequestPermission) {
		return (
			<div>
				<Card>
					<CardContent>You don't have permission to view any Service Requests at this time. Please contact your Systems Administrator for access.</CardContent>
				</Card>
			</div>
		)
	}

	return (
		<div className="w-full flex flex-col">
			<SwitchView
				viewServiceRequestPermission = {props.viewServiceRequestPermission}
				createServiceRequestPermission = {props.createServiceRequestPermission}
				updateServiceRequestPermission = {props.updateServiceRequestPermission}
				deleteServiceRequestPermission = {props.deleteServiceRequestPermission}
				pageType = { props?.pageType }
				customFilterData = { props?.customFilterData }
				/>
		</div>
	);

}

function SwitchView({
	 viewServiceRequestPermission, createServiceRequestPermission,
		updateServiceRequestPermission, deleteServiceRequestPermission, pageType, customFilterData
}) {
	return(
		<ListView 
			viewServiceRequestPermission = {viewServiceRequestPermission}
			createServiceRequestPermission = {createServiceRequestPermission}
			updateServiceRequestPermission = {updateServiceRequestPermission}
			deleteServiceRequestPermission = {deleteServiceRequestPermission}
			pageType = { pageType }
			customFilterData={customFilterData}
		/>
	)
}

export default withRouter(EndUsersAccountsTable)
